import { Component, EventEmitter, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core';
import { BaseModalComponent } from '../../ui-components/modal/base-modal-component';
import { CloseBtnComponent } from '../../@components/close-btn/close-btn.component';
import { SharedModule } from '../../ui-components/shared.module';
import { TranslatePipe } from '@ngx-translate/core';
import { CircleUserIconComponent } from '../../../@icons/circle-user-icon.component';
import { MessageIconComponent } from '../../../@icons/message-icon.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'vw-report-modal',
  imports: [
    CloseBtnComponent,
    SharedModule,
    TranslatePipe,
    CircleUserIconComponent,
    MessageIconComponent,
    ReactiveFormsModule,
    FormsModule
  ],
  templateUrl: './report-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './report-modal.component.scss'
})
export class ReportModalComponent extends BaseModalComponent implements OnChanges {
  message: any;
  choices = ['wrong', 'missing', 'inappropriate', 'other'];
  selectedChoice: string;
  @Output() onReport = new EventEmitter<any>();

  constructor() {
    super();
  }
  ngOnChanges() {
    //TODO - Implement this method
  }

  onSendButtonClick() {
    this.close();
    this.onReport.emit();
  }

  onChoiceSelected(choice: any) {
    this.selectedChoice = choice;
  }
}
